import { getUID } from '@redviking/argonaut-util/src/getUID';
import { getAllAppletVariables } from '@redviking/argonaut-util/src/mes/appletUtil';
import type { UiNodeSpec } from './UiNodeSpec';
import { createNodeSocket } from '../../sync-utils/create-node-socket';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { getSocketTypeForVarId } from '../socket-var-helpers';

export const varAssignedUiNodeSpec: UiNodeSpec<'varAssigned'> = {
    requiredSockets: (node, _, availableOutputSockets) => ({
        required: [],
        conditionallyRequired: [
            {
                kind: 'or',
                availableOptions: availableOutputSockets,
            },
        ],
    }),
    cfg: () => ({ controlValues: { changesOnly: false, varId: '' }, id: getUID(), kind: 'varAssigned', disabled: false }),
    controls: getNodeCfg => ({
        changesOnly: { cfg: { kind: 'boolean', label: 'Changes Only' }, nodeCfg: getNodeCfg(), value: getNodeCfg().controlValues.changesOnly },
        varId: {
                cfg: {
                    kind: 'selectVar',
                    allVars: true,
                    onSelect: val => {
                        const nodeCfg = getNodeCfg();
                        const controlValues: NodeCfg<'varAssigned'>['controlValues'] = {
                            ...nodeCfg.controlValues,
                            varId: val,
                        };
                        const newNodeCfg = {
                            ...nodeCfg,
                            controlValues,
                        };
                        createNodeSocket({
                            newNodeCfg,
                        });
                    },
                },
                nodeCfg: getNodeCfg(),
                value: getNodeCfg().controlValues.varId,
            },
    }),
    inputs: () => ({}),
    kindLabel: 'Variable Assigned',
    nodeCategory: 'variable',
    outputs: (nodeCfg) => ({
        trigger: { socket: 'event', label: 'Trigger' },
                newValue: { socket: getSocketTypeForVarId(nodeCfg.controlValues.varId), label: 'New Value' },
                oldValue: { socket: getSocketTypeForVarId(nodeCfg.controlValues.varId), label: 'Old Value' },
    }),
    validator: (node, appletDesignVersionConfig) => {
        const errors: Record<string, string> = {};
        if (!node.controlValues.varId) {
            errors.varId = 'Variable is required';
        }
        const allAppletVariables = getAllAppletVariables(appletDesignVersionConfig);
        if (!allAppletVariables[node.controlValues.varId]) {
            errors.varId = 'Variable is not a valid variable';
        }
        return Object.keys(errors).length ? errors : true;
    },
};
